import { Outlet, useLocation } from "react-router-dom";
import FrontHeader from "../../shared/FrontHeader";
import { setTitle } from "../../helpers/MetaTag";
import CompanyCard from "../../components/sections/front/CompanyCard";
import OrganizationCard from "../../components/sections/front/OrganizationCard";
import MenuCard from "../../components/sections/front/MenuCard";
import FooterCard from "../../components/sections/front/FooterCard";
import { useQuery } from "@tanstack/react-query";
import { profileDetails } from "../../services/ProfileService";

const FrontLayout = ({ metaTitle, isSidebar = false }) => {
  setTitle(metaTitle);

  const location = useLocation();

  // Don't call API for "/" or "/job"
  const shouldFetchProfile = location.pathname !== "/job";
  // location.pathname !== "/" && location.pathname !== "/job";

  const { data, isLoading } = useQuery({
    queryKey: ["profile-details"],
    queryFn: profileDetails,
    enabled: shouldFetchProfile, // 👈 condition here
  });

  const user = data?.data;
  const organization = user?.organization;

  return (
    <div className="bg-gray-100 min-h-screen">
      <FrontHeader />

      <div className="w-full px-3 md:px-6 max-w-full md:md:max-w-[1200px] 3xl:max-w-6xl mx-auto flex flex-col md:flex-row gap-4 items-start mt-4">
        {isSidebar && (
          <div className="w-full md:w-[35%] lg:w-[28%] md:sticky md:top-[72px] md:h-[calc(100vh-72px)]">
            <div className="space-y-2">
              <CompanyCard />
              <div className="bg-white border border-gray-200 rounded-lg">
                <OrganizationCard />

                <MenuCard organization={organization} loading={isLoading} />
              </div>
              <div className="hidden md:block">
                <FooterCard />
              </div>
            </div>
          </div>
        )}

        <div
          className={`${isSidebar ? "w-full md:w-[65%] lg:w-[72%]" : "w-full"}`}
        >
          <Outlet />
        </div>

        {isSidebar && (
          <div className="mb-4 mt-3 md:hidden">
            <FooterCard />
          </div>
        )}
      </div>
    </div>
  );
};

export default FrontLayout;
